import Box from 'v2/components/UI/Box';
import useBiometricsNurseries from './hooks/useBiometricsNurseries';
import Icon from 'v2/components/Icon';
import Text from 'v2/components/UI/Text';
import Select from 'v2/components/Select';
import MultiSelectAll from 'components/MultiSelect';
import LineChart from '../../UI/LineChart';

const BiometricsNurseries = () => {
  const {
    optionsnNurseries,
    selectedNurseries,
    optionsParameters,
    selectedParameters,

    handleChangeParameters,
    setSelectedParameters,
  } = useBiometricsNurseries();

  const renderTextEmptyMessageOrGraph = () => {
    if (optionsnNurseries.length === 2 && optionsParameters.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Nenhum dado encontrado
          </Text>
        </Box>
      );
    }

    if (selectedParameters.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Selecione ao menos um parâmetro
          </Text>
        </Box>
      );
    }

    return <LineChart data={selectedParameters} />;
  };

  return (
    <Box
      flexDirection="column"
      gap={30}
      padding={30}
      background="#fff"
      borderRadius={18}
    >
      <Box gap={10} alignItems="center">
        <Icon iconName="StraightenOutlined" htmlColor="#005f47" size={30} />
        <Text fontSize={24} fontWeight={700} color="#005f47">
          Biometria por Viveiros
        </Text>
      </Box>

      <Box gap={20}>
        <Select
          backgroundColor="#b7ffbd"
          options={optionsnNurseries}
          value={selectedNurseries}
          labelId="supplies-label"
          selectId="supplies-id"
          label="Viveiros"
          onChange={handleChangeParameters}
          defaultValue={'default'}
        />

        <Box>
          <MultiSelectAll
            label="Parâmetros"
            id="shrimppond"
            allSelected={
              optionsParameters?.length === optionsnNurseries?.length
            }
            labelOption="name"
            onChange={setSelectedParameters}
            options={optionsParameters}
            value={selectedParameters}
            error={false}
            helperText={false}
            renderOptionLabel={false}
            labelSelectAllButtonFilterOptions={false}
            labelCustomRenderOption={false}
          />
        </Box>
      </Box>
      {renderTextEmptyMessageOrGraph()}
    </Box>
  );
};

export default BiometricsNurseries;
